import { z } from 'zod';

import { ItemSelection } from '@/features/dashboard/components/AppForm/AppForm/components/ItemSelection';
import { TabName } from '@/features/dashboard/components/AppForm/AppForm/components/TabName';
import type { BasicTableValues } from '@/features/dashboard/components/AppForm/AppForm/context/types';
import { DrawerStep } from '@/features/dashboard/components/Drawer/types';
import { BASIC_DATA_TABLE_MAX_ITEMS } from '@/features/dashboard/constants/const';
import type { TableWidgetV2 } from '@/features/dashboard/types';
import { AppType } from '@/features/dashboard/types';

import type { FormAppDefinition } from '../types';
import { buildTable, NameSchema, SymbolsStateSchema, tableToFormValues } from './_helpers';

export const basicTableDefinition: FormAppDefinition<BasicTableValues, TableWidgetV2> = {
  type: AppType.Table,
  drawerStep: DrawerStep.SelectBasicDataTable,
  dashboardControls: { edit: true },
  widgetControls: { export: true },
  maxItems: BASIC_DATA_TABLE_MAX_ITEMS,
  initialValues: {
    name: 'Data Table',
    type: AppType.Table,
    symbols: { active: [], backlog: [] }
  },
  schema: z.object({
    id: z.string().optional(),
    type: z.literal(AppType.Table),
    name: NameSchema,
    symbols: SymbolsStateSchema
  }),
  heading: { title: 'Configure data table', subtitle: 'Set up your table preferences and data' },
  Form: () => (
    <div className='flex flex-col gap-6'>
      <TabName />
      <ItemSelection />
    </div>
  ),
  toWidget: values => buildTable(values.name, values.symbols, null, values.id),
  canEditWidget: (w): w is TableWidgetV2 => w.type === 'table',
  fromWidget: w => tableToFormValues(w, AppType.Table)
};
